// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addStakingRisk_addStakingWrapper__4oJ02 {
    /* height: 380px !important; */
}

.addStakingRisk_addStakingWrapper__4oJ02:hover {
    display: block;
    background: #FDFDFD;
}

/* .add_staking {
    top: 48% !important;
} */

/* .wrapper.zoom__page .card__risk .add_staking {
    top: 43% !important;
} */
.addStakingRisk_loader__z2VMo {
    width: 18px;
    height: 18px;
    border: 4px solid rgba(255, 255, 255, 0.4);
    border-top: 4px solid #ffffff;
    border-radius: 50%;
    animation: addStakingRisk_spin__f6xyE 0.7s linear infinite;
    margin: auto;
}

@keyframes addStakingRisk_spin__f6xyE {
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/Modal/AddStakingRisk/addStakingRisk.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;GAEG;;AAEH;;GAEG;AACH;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,0DAAoC;IACpC,YAAY;AAChB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".addStakingWrapper {\n    /* height: 380px !important; */\n}\n\n.addStakingWrapper:hover {\n    display: block;\n    background: #FDFDFD;\n}\n\n/* .add_staking {\n    top: 48% !important;\n} */\n\n/* .wrapper.zoom__page .card__risk .add_staking {\n    top: 43% !important;\n} */\n.loader {\n    width: 18px;\n    height: 18px;\n    border: 4px solid rgba(255, 255, 255, 0.4);\n    border-top: 4px solid #ffffff;\n    border-radius: 50%;\n    animation: spin 0.7s linear infinite;\n    margin: auto;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addStakingWrapper": `addStakingRisk_addStakingWrapper__4oJ02`,
	"loader": `addStakingRisk_loader__z2VMo`,
	"spin": `addStakingRisk_spin__f6xyE`
};
export default ___CSS_LOADER_EXPORT___;
